import * as types from './actions';

export const initialState = {
  birthday: ['']
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.CHANGE_BIRTHDAY:
      return { ...state, birthday: payload.birthday };
    case 'RESET_STORE':
      return { ...state, ...initialState };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/pages/Birthday/reducer.js